import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import { ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const LeaderboardPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { eventType, leaderboard } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL,
        {
          params: {
            eventType,
            leaderboard,
          },
        }
      )}
      replace
    />
  );
};

export default LeaderboardPage;
